// Hero-блок ЛК: kicker + заголовок + подпись + countdown с маркером «билет активен».
export const accountHeroSection = {
  kicker: 'Личный кабинет участника',
  titleReady: 'Билет готов. Осталось просто прийти на форум.',
  titleWelcome: 'Добро пожаловать',
  subtitle:
    '18 июня 2026, Новосибирск. На входе покажите QR-код из кабинета или письма после оплаты.',
  countdown: {
    label: 'До форума',
    activeBadge: 'билет активен',
    pendingBadge: 'ожидает оплаты',
    units: ['дн', 'ч', 'мин', 'сек']
  }
};
